_collow.components.LaTeX = class LaTeX extends _collow.components.Base {
  root;
  elements;
  params;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    this.init();
  }

  init = () => {
    this.renderLatex();
  };

  /**
   * Render LaTeX mathematical expressions
   */
  renderLatex = () => {
    // Try multiple ways to get the latex body
    let latexBody = this.params.body ||
      this.params.latexBody ||
      this.root.dataset.latexBody ||
      this.root.getAttribute('data-latex:body');

    let isInline = this.params.inline ||
      this.params.latexInline ||
      this.root.dataset.latexInline ||
      this.root.getAttribute('data-latex:inline');

    // Convert inline to boolean
    isInline = isInline === 'true' || isInline === true;

    if (!latexBody) {
      console.warn('LaTeX component: No body content found');
      this.root.innerHTML = '<span class="latex-error">No LaTeX content found</span>';
      return;
    }

    console.log('Rendering LaTeX:', { body: latexBody, inline: isInline });

    try {
      // Set the LaTeX content with proper MathJax delimiters
      if (isInline) {
        this.root.innerHTML = `\\(${latexBody}\\)`;
        this.root.classList.add('latex-inline-container');
      } else {
        this.root.innerHTML = `\\[${latexBody}\\]`;
        this.root.classList.add('latex-block-container');
      }

      // Process with MathJax
      this.processMathJax();
    } catch (error) {
      console.error('Error rendering LaTeX:', error);
      this.root.innerHTML = `<span class="latex-error">LaTeX Error: ${latexBody}</span>`;
    }
  };

  /**
   * Process the element with MathJax
   */
  processMathJax = () => {
    if (window.MathJax && window.MathJax.typesetPromise) {
      // Use MathJax to render the mathematics
      window.MathJax.typesetPromise([this.root]).then(() => {
        console.log('MathJax rendering completed for:', this.root);
      }).catch((err) => {
        console.error('MathJax rendering failed:', err);
        // Fallback to basic styling
        this.fallbackRender();
      });
    } else if (window.MathJax && window.MathJax.Hub) {
      // Fallback for older MathJax versions
      window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, this.root]);
    } else {
      console.warn('MathJax not available, using fallback rendering');
      this.fallbackRender();
    }
  };

  /**
   * Fallback rendering when MathJax is not available or fails
   */
  fallbackRender = () => {
    let content = this.root.innerHTML;

    // Remove MathJax delimiters for fallback
    content = content.replace(/\\\[|\\\]|\\\(|\\\)/g, '');

    // Convert \text{...} to regular text
    content = content.replace(/\\text\{([^}]*)\}/g, '$1');

    // Handle basic math formatting
    content = content.replace(/\^([0-9]+)/g, '<sup>$1</sup>');
    content = content.replace(/_([0-9]+)/g, '<sub>$1</sub>');

    this.root.innerHTML = `<span class="latex-fallback">${content}</span>`;
  };
};